import { defineAsyncComponent } from 'vue';

// Standard modules
import ButtonModule from './ButtonModule.vue';
import AssetModule from './AssetModule.vue';
import TextModule from './TextModule.vue';
import UploadModule from './UploadModule.vue';
import PlaceholderModule from './PlaceholderModule.vue';
import PreviewModule from './PreviewModule.vue';
import AdvancedButtonModule from './AdvancedButtonModule.vue';

// Interactive modules
import MultipleSelectionModule from './interactive-modules/MultipleSelectionModule.vue';
import PromptModule from './interactive-modules/PromptModule.vue';
import SingleSelectionModule from './interactive-modules/SingleSelectionModule.vue';
import BlockModule from './interactive-modules/BlockModule.vue';

// Module options
const ButtonModuleOptions = defineAsyncComponent(() => import(/* webpackChunkName: "edit-mode" */ './ButtonModuleOptions.vue'));
const AssetModuleOptions = defineAsyncComponent(() => import(/* webpackChunkName: "edit-mode" */ './AssetModuleOptions.vue'));
const TextModuleOptions = defineAsyncComponent(() => import(/* webpackChunkName: "edit-mode" */ './TextModuleOptions.vue'));
const UploadModuleOptions = defineAsyncComponent(() => import(/* webpackChunkName: "edit-mode" */ './UploadModuleOptions.vue'));
const PlaceholderModuleOptions = defineAsyncComponent(() => import(/* webpackChunkName: "edit-mode" */ './PlaceholderModuleOptions.vue'));
const AdvancedButtonModuleOptions = defineAsyncComponent(() => import(/* webpackChunkName: "edit-mode" */ './AdvancedButtonModuleOptions.vue'));

export default {
  ButtonModuleOptions,
  ButtonModule,
  AssetModuleOptions,
  AssetModule,
  TextModuleOptions,
  TextModule,
  MultipleSelectionModule,
  PromptModule,
  SingleSelectionModule,
  PlaceholderModule,
  PlaceholderModuleOptions,
  PreviewModule,
  BlockModule,
  UploadModule,
  UploadModuleOptions,
  AdvancedButtonModule,
  AdvancedButtonModuleOptions,
};
